import React from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";

import "./App.css";
import "./index.css";

import GetDataFromAPI from "./components/GetDataFromAPI";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Pour from "./pages/Pour";
import Cart from "./pages/Cart";
import Order from "./pages/Order"
import Stripe from "./pages/Stripe";
import Info from "./pages/Info";
import Scan from "./pages/Scan";
import User from "./pages/User";
import Login from "./components/User/Login";
import Register from "./components/User/Register";
import ComponentUser from "./components/User";
import PaymentSuccess from './pages/PaymentSuccess';
import ResetPassword from "./components/User/ResetPassword";

import withAuth from './components/withAuth';

const ProtectedUser = withAuth(User);

function App() {
    return (
        <Router>

            <div className="buble_bg">

                {/* <Install/> */}
                <GetDataFromAPI/>
                <Header/>
                <ComponentUser/>
                <Footer></Footer>
                {/* <Navigation/> */}

                <main className="z-0 overflow-auto">
                    <Routes>
                        <Route path="/" element={<Scan/>}/>
                        <Route path="*" element={<Scan/>}/>
                        <Route path="/order" element={<Order/>}/>
                        <Route path="/cart/" element={<Home/>}/>
                        <Route path="/cart/:id" element={<Cart/>}/>
                        <Route path="/cart/:id/pour/:pid" element={<Pour/>}/>
                        <Route path="/cart/:id/:pid" element={<Pour/>}/>
                        <Route path="/stripe" element={<Stripe/>}/>
                        <Route path="/stripe/success/:paymentBackTrackId" element={<PaymentSuccess/>}/>
                        <Route path="/info" element={<Info/>}/>
                        <Route path="/user" element={<ProtectedUser/>}/>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/register" element={<Register/>}/>
                        <Route path="/reset-password" element={<ResetPassword/>}/>
                    </Routes>
                </main>

            </div>

        </Router>
    );
}

export default App;
